module.exports = "<div class=\"nav-item\">\n  <a class=\"nav-link\">{{item.title}}</a>\n</div>"